import {useGuestHost} from './useUniversalFetch';

export type MaltEnvironnement = 'DEV' | 'PRODUCTION' | 'INTEGRATION' | 'DEV_INTEGRATION' | 'UNKNOWN';

const devDomainRegex = /^https?:\/\/dev([a-z]{2})?\.malt\.[a-z]+\/?$/;
const devIntegrationDomainRegex = /^https?:\/\/(dev)([a-z]{2})?\.integration\.malt\.[a-z]+\/?$/;
const integrationDomainRegex = /^https?:\/\/((www|[a-z]{2})\.)?integration\.malt\.[a-z]+\/?$/;
const productionDomainRegex = /^https?:\/\/((www|nordics|[a-z]{2})\.)?malt\.[a-z]+\/?$/;

export function useMaltEnvironnement(): MaltEnvironnement {
    try {
        const hostUrl = useGuestHost();

        if (devDomainRegex.test(hostUrl)) {
            return 'DEV';
        } else if (devIntegrationDomainRegex.test(hostUrl)) {
            return 'DEV_INTEGRATION';
        } else if (integrationDomainRegex.test(hostUrl)) {
            return 'INTEGRATION';
        } else if (productionDomainRegex.test(hostUrl)) {
            return 'PRODUCTION';
        } else {
            return 'UNKNOWN';
        }
    } catch {
        return 'UNKNOWN';
    }
}
